import cn from 'classnames';

import * as styles from './styles.css';
import { beautify } from '../../../../number';
import { IPinViewModel } from '../../getPinViewModel';
import { getCounterRenderer } from '../counter/getCounterRenderer';
import { getIconRenderer } from '../icon/getIconRenderer';

export interface IPricePillProps {
  /** Пин выделен кликом или наведением: пилюля и её части инвертируются */
  isHighlighted: boolean;
}

/**
 * Тело обычного пина: каунтер (у мультипина), цена и иконка.
 * Обёртку `.pin` с anchor и data-атрибутами собирает BalloonManager.
 */
export function getPricePillRenderer(model: IPinViewModel, { isHighlighted }: IPricePillProps): string {
  const { price, isPriceFrom, isViewed, icon, counterLabel, isMultiPin } = model;

  // Каунтер есть только у мультипина; он же переключает цену на «от» и вёрстку пилюли
  const counter = counterLabel ? getCounterRenderer(counterLabel, { isHighlighted, isViewed }) : '';
  const priceLabel = price === null ? '' : `${isPriceFrom ? 'от ' : ''}${beautify(price)} ₽`;
  const iconMarkup = icon ? getIconRenderer(icon, { isViewed, isHighlighted, isMultiPin }) : '';

  return `<div class="${cn(
    styles['balloon'],
    isMultiPin && styles['multi'],
    isViewed && styles['viewed'],
    isHighlighted && styles['active'],
  )}" data-testid="pin-price-pill">${counter}<div class="${styles['price']}" data-testid="pin-price">${priceLabel}</div>${iconMarkup}</div>`;
}
